module.exports = __webpack_public_path__ + "static/media/edMain01.a9d0c7af.png";